import moment from 'moment'
import { Dialog } from 'primereact/dialog'
import React, { useState, useEffect } from 'react'
import { PHARMA_ACTIVE_TYPE, PHARMA_SHIPPING_TYPE, NOTIFICATION_MESSAGE_TYPE } from '../../../constants'
import MESSAGES from '../../../constants/Messages'
import { sendEmailForAssistance } from '../../../utils/ExceptionHandlingUtil'
import { useTranslation } from 'react-i18next'
import { CustomPopup } from '../../../common/Popup/CustomPopup'
const UldValidationPopupdg = ({

    displayDgULDItemPopup,
    setDisplayDgULDItemPopup,
    handleClear,
    selectedDestination,
    selectedOrigin,
    shippingDate,
    shippingItem,
    setIsLoading,
    setNotificationMessage,
    setNotificationType,
    additionalSccs,
    popupNotificationPopup,
    exceptionTypeDg,
    spUnid,
    setSpUnid,
    unidList,
    setShippingType,

}) => {
    const [exceptionType, setExceptionType] = useState(exceptionTypeDg)
    const [itemList, setItemList] = useState()

    const { t, i18n } = useTranslation(['labels', 'errors'])

    const handleCancel = () => {
        setShippingType('LOOSE')
        setDisplayDgULDItemPopup(false)

    }

    useEffect(() => {

        let unidListArray = []

        unidList.map(item =>
            unidListArray.push(item.unid))

        setItemList(unidListArray)

    }, [unidList])



    const handleConfirm = async () => {
        const attributes = [
            {
                key: 'origin',
                value: selectedOrigin ? selectedOrigin.code : null,
            },
            {
                key: 'destination',
                value: selectedDestination ? selectedDestination.code : null,
            },
            {
                key: 'shippingItem',
                value: shippingItem &&
                    shippingItem?.description &&
                    shippingItem?.product
                    ? `${shippingItem.description}-${shippingItem.product}`
                    : null,
            },
            {
                key: 'shippingDate',
                value: shippingDate ? moment(shippingDate).format('DD MMM, YYYY') : null,
            },
            {
                key: 'sccs',
                value: getSccs(additionalSccs),
            },
            {
                key: 'unid',
                value: itemList ? itemList : null,
            },
            {
                key: "shippingProduct",
                value: shippingItem &&
                    shippingItem?.product
                    ? `${shippingItem.product}`
                    : null,
            },
            {
                key: "shippingCommodity",
                value: shippingItem &&
                    shippingItem?.description
                    ? `${shippingItem.description}`
                    : null,
            },
            {
                key: "emailType",
                value: "enquiryEmail"
            },
            {
                key: "enquiryReason",
                value: t('COMMON.DG_ULD_ENQUIRY'),
            },


        ]
        const replacements = {
            '%DESCRIPTION%': shippingItem ? shippingItem.description : '',
        }
        const response = await sendEmailForAssistance(
            'DG_ULD',
            setIsLoading,
            attributes,
            replacements

        )
        setDisplayDgULDItemPopup(false)
        if (response) {
            setNotificationMessage(t(MESSAGES.ASSISTANCE_MSG, { ns: 'errors' }))
            setNotificationType(NOTIFICATION_MESSAGE_TYPE.INFO)
        } else {
            setNotificationMessage(
                t(MESSAGES.MAIL_ASSISTANCE_FAILS, { ns: 'errors' })
            )
            setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR)
        }
        window.scrollTo(0, 0)
        handleClear()
    }

    const getSccs = (additionalSccs) => {
        if (additionalSccs && additionalSccs.length) {
            return additionalSccs.map((e) => e.scc).toString()
        } else {
            return null
        }
    }

    return (
        <CustomPopup
            isVisible={displayDgULDItemPopup}
            footerPriBtnLabel={t('COMMON.OK')}
            footerPriBtnClick={handleConfirm}
            footerSecBtnLabel={t('COMMON.CANCEL')}
            footerSecBtnClick={handleCancel}
            onClose={handleCancel}
            headerComponent={{ mainHeader: t('BOOKING.ASSISTANCE_HEAD') }}
            body={<p >
                {t(MESSAGES.ASSISTANCE_MSG_CONTAINER_DG, {
                    item: shippingItem?.description,
                    ns: 'errors',
                })}
            </p>}
        />

    )
}

export default UldValidationPopupdg
